import { jsx, css } from '@emotion/react';

import Section from './oc-section';
import { connectLocation } from '../../location/LocationConnectors';
import RichText from '../oc-rich-text';

const styles = css`
  ul {
    display: flex;
    flex-dirextion: row;
    flex-wrap: wrap;
    padding-left: 0;

    li {
      width: 100%;
      list-style-position: outside;
      padding-left: 0;
      margin-left: 20px;
      font-weight: bold;
      font-size: 21px;

      ::marker {
        margin-right: 10px;
      }

      @media (max-width: 1199px) {
        font-size: 18px;
      }
    }
  }
`;

/*
  Data comes in like this (edited for clarity)

    [
      {
        proper_name: "Mechanical Pipe and Equipment",
        slug: "mechanical",
      },
      {
        proper_name: "Piping",
        slug: "mechanical/piping",
      },
      {
        proper_name: "Underground",
        slug: "mechanical/piping/underground",
      },
      {
        proper_name: "Process Piping",
        slug: "mechanical/piping/underground/process-piping",
      },
    ]

  And we woud like to get a an array like this

    ['Mechanical Pipe and Equipment', 'Piping', 'Underground', 'Process Piping']

  This in turns means we need to resolve all parent names, as well as mark parent applications so they are not displayed.
  Below code
  1. Adds isParent to applications which have sub-application
  2. Adds resolvedName to innermost sub-application
  3. Adds missingParent to sub-applications with missing parent objects (example: vehicles/near-to-engine/rv)
  4. Returns list of applications with those extra parameters, filtered to remove parents and orphans

*/
const prepare = applications => {
  applications.map(app => {
    const resolvedName = [];
    // 1
    if (applications.find(other => other.slug.indexOf(`${app.slug}/`) === 0)) {
      app.isParent = true;
    }
    // 2
    if (!app.isParent && app.slug.indexOf('/') > 0) {
      const partialPrefixes = app.slug.split('/');
      // Remove own slug from the end of the list
      partialPrefixes.pop();
      _.times(partialPrefixes.length, i => {
        const parentSlug = partialPrefixes.slice(0, i + 1).join('/');
        const parent = applications.find(a => a.slug === parentSlug);
        // 3
        if (parent) {
          resolvedName.push(parent.proper_name);
        } else {
          app.missingParent = true;
        }
      });
    }
    resolvedName.push(app.proper_name);
    app.resolvedName = resolvedName;
    return app;
  });
  // 4
  return applications.filter(applicationsFilters);
};

const applicationsFilters = application => !application.isParent && !application.missingParent;

const Applications = connectLocation(({ t, applications, intro, heading, anchor, className }) => (
  <Section anchor={anchor} css={styles} className={className}>
    <h2>
      <RichText content={heading} />
    </h2>
    {intro ? (
      <p>
        <RichText content={intro} />
      </p>
    ) : null}
    <ul>
      {_.sortBy(prepare(applications), 'uid').map(({ uid, resolvedName }) => (
        <li key={uid}>
          <RichText content={resolvedName.join(' > ')} />
        </li>
      ))}
    </ul>
  </Section>
));

Applications.WrappedComponent.displayName = 'Applications';

export default Applications;
